export default state => state.auth.lockdown.totalLockdownSeconds > 0;

